export default [
    {
        "competency": "توسعه کسب و کار",
        "subCompetencies": [
            {
                "title": "برنامه ریزی راهبردی",
                "details": [
                    {
                        "description": "برنامه ریزی استراتژیک هلدینگ",
                        "requiredCompetencyLevel": "خیلی زیاد"
                    }
                ]
            },
            {
                "title": "شناسایی فرصت های سرمایه گذاری",
                "details": [
                    {
                        "description": "تهیه گزارشات رقبای بورسی",
                        "requiredCompetencyLevel": "کم"
                    },
                    {
                        "description": "تدوین ماهنامه اقتصادی",
                        "requiredCompetencyLevel": "متوسط"
                    },
                    {
                        "description": "انتشار فصلنامه اقتصادی",
                        "requiredCompetencyLevel": "زیاد"
                    },
                    {
                        "description": "مطالعات بازار",
                        "requiredCompetencyLevel": "زیاد"
                    }
                ]
            },
            {
                "title": "جذب یا توسعه کسب و کار",
                "details": [
                    {
                        "description": "تاسیس شرکت",
                        "requiredCompetencyLevel": "خیلی زیاد"
                    }
                ]
            },
            {
                "title": "تامین منابع و پشتیبانی سرمایه گذاری",
                "details": [
                    {
                        "description": "جذب سرمایه گذار خارجی داخلی",
                        "requiredCompetencyLevel": "زیاد"
                    },
                    {
                        "description": "بررسی و ایجاد شرکت‌های تجاری",
                        "requiredCompetencyLevel": "زیاد"
                    }
                ]
            },
            {
                "title": "سیاست گذاری زنجیره ارزش",
                "details": [
                    {
                        "description": "بررسی و تحلیل و شناسایی فرصت تکمیل زنجیره ارزش",
                        "requiredCompetencyLevel": "زیاد"
                    },
                    {
                        "description": "امور دانش بنیان",
                        "requiredCompetencyLevel": "زیاد"
                    },
                    {
                        "description": "عقد تفاهم نامه مشترک توسعه",
                        "requiredCompetencyLevel": "زیاد"
                    }
                ]
            }
        ]
    },
    {
        "competency": "راهبری کلان شرکت های تابعه",
        "subCompetencies": [
            {
                "title": "گزارش گیری",
                "details": [
                    {
                        "description": "دریافت صورت های مالی شرکت های تابعه",
                        "requiredCompetencyLevel": "متوسط"
                    }
                ]
            },
            {
                "title": "سیاست گذاری و برنامه ریزی",
                "details": [
                    {
                        "description": "تصویب و نظارت بر همسویی سند راهبردی شرکت های تابعه",
                        "requiredCompetencyLevel": "زیاد"
                    },
                    {
                        "description": "پایش و برنامه ریزی برای پیاده سازی کامل سیاست های راهبری مطلوب شرکت های تابعه",
                        "requiredCompetencyLevel": "زیاد"
                    },
                    {
                        "description": "تعیین سیاست های بازاریابی و فروش",
                        "requiredCompetencyLevel": "زیاد"
                    },
                    {
                        "description": "تعیین سیاست های توسعه زیرساخت",
                        "requiredCompetencyLevel": "زیاد"
                    },
                    {
                        "description": "پیش بینی، برنامه ریزی و بودجه ریزی",
                        "requiredCompetencyLevel": "زیاد"
                    }
                ]
            },
            {
                "title": "هم افزایی و تسهیل گری",
                "details": [
                    {
                        "description": "ارائه خدمات مشاوره در زمینه مدیریت منابع انسانی",
                        "requiredCompetencyLevel": "زیاد"
                    },
                    {
                        "description": "ارائه خدمات مشاوره در زمینه مدیریت مالی مالیاتی و بیمه",
                        "requiredCompetencyLevel": "زیاد"
                    },
                    {
                        "description": "بررسی پرونده های قضایی شرکت های تابعه",
                        "requiredCompetencyLevel": "زیاد"
                    },
                    {
                        "description": "شناسایی فرصت های هم افزایی در زنجیره ارزش شرکت های تابعه",
                        "requiredCompetencyLevel": "زیاد"
                    },
                    {
                        "description": "مشارکت در تامین منابع مالی و تضامین مالی",
                        "requiredCompetencyLevel": "زیاد"
                    },
                    {
                        "description": "شناسایی و هم افزایی جهت رفع موانع امور جاری شرکت ها",
                        "requiredCompetencyLevel": "زیاد"
                    },
                    {
                        "description": "ارائه خدمات مشاوره فنی",
                        "requiredCompetencyLevel": "زیاد"
                    },
                    {
                        "description": "مشاوره در انعقاد قراردادهای شرکت های تابعه",
                        "requiredCompetencyLevel": "زیاد"
                    },
                    {
                        "description": "تسهیلگری ورود شرکت‌های تابعه به بورس",
                        "requiredCompetencyLevel": "زیاد"
                    },
                    {
                        "description": "ارائه خدمات مشاوره در زمینه افزایش سرمایه",
                        "requiredCompetencyLevel": "زیاد"
                    }
                ]
            },
            {
                "title": "تنظیم گری",
                "details": [
                    {
                        "description": "مدیریت ریسک سازمانی شرکت های تابعه",
                        "requiredCompetencyLevel": "زیاد"
                    },
                    {
                        "description": "مدیریت و کنترل پروژه های شرکت های تابعه",
                        "requiredCompetencyLevel": "زیاد"
                    }
                ]
            },
            {
                "title": "نظارت عالی",
                "details": [
                    {
                        "description": "پایش و ارزیابی عملکرد مالی و اقتصادی شرکت های تابعه",
                        "requiredCompetencyLevel": "زیاد"
                    },
                    {
                        "description": "پایش استراتژی های شرکت های تابعه",
                        "requiredCompetencyLevel": "زیاد"
                    },
                    {
                        "description": "بررسی و نظارت بر مطالعات امکانسنجی پروژه های توسعه ای",
                        "requiredCompetencyLevel": "زیاد"
                    },
                    {
                        "description": "برگزاری مجامع",
                        "requiredCompetencyLevel": "زیاد"
                    },
                    {
                        "description": "پیگیری تکالیف مجامع",
                        "requiredCompetencyLevel": "زیاد"
                    },
                    {
                        "description": "نظارت عالی بر ایمنی،بهداشت ومحیط زیست شرکت های تابعه",
                        "requiredCompetencyLevel": "زیاد"
                    },
                    {
                        "description": "نظارت بر صورتجلسات هیئت مدیره شرکت های تابعه",
                        "requiredCompetencyLevel": "زیاد"
                    },
                    {
                        "description": "مدیریت گزارش های حسابرسی شرکت های تابعه",
                        "requiredCompetencyLevel": "زیاد"
                    },
                    {
                        "description": "نظارت بر جلسات عالی بازرگانی « کمیسیون معاملات»",
                        "requiredCompetencyLevel": "زیاد"
                    },
                    {
                        "description": "نظارت بر اجرای توافقنامه های هم افزایی در زنجیره ارزش شرکتهای تابعه",
                        "requiredCompetencyLevel": "زیاد"
                    }
                ]
            }
        ]
    },
    {
        "competency": "گزارش دهی",
        "subCompetencies": [
            {
                "title": "تهیه گزارشات فعالیت هیئت مدیره هلدینگ",
                "details": [
                    {
                        "description": null,
                        "requiredCompetencyLevel": "متوسط"
                    }
                ]
            },
            {
                "title": "تهیه گزارش امکانسنجی پروژه های سرمایه گذاری و پیمانکاری",
                "details": [
                    {
                        "description": null,
                        "requiredCompetencyLevel": "متوسط"
                    }
                ]
            },
            {
                "title": "تهیه گزارشات تلفیقی صورت مالی هلدینگ",
                "details": [
                    {
                        "description": null,
                        "requiredCompetencyLevel": "متوسط"
                    }
                ]
            },
            {
                "title": "تهیه گزارشات تغییرات سهام",
                "details": [
                    {
                        "description": null,
                        "requiredCompetencyLevel": "متوسط"
                    }
                ]
            },
            {
                "title": "تدوین گزارش عملکرد دوره ای",
                "details": [
                    {
                        "description": null,
                        "requiredCompetencyLevel": "متوسط"
                    }
                ]
            },
            {
                "title": "تهیه و ارائه صورتجلسات هیئت مدیره هلدینگ",
                "details": [
                    {
                        "description": null,
                        "requiredCompetencyLevel": "متوسط"
                    }
                ]
            },
            {
                "title": "تهیه گزارشات دوره ای ریسک",
                "details": [
                    {
                        "description": null,
                        "requiredCompetencyLevel": "متوسط"
                    }
                ]
            },
            {
                "title": "تهیه گزارشات دوره ای HSE",
                "details": [
                    {
                        "description": null,
                        "requiredCompetencyLevel": "متوسط"
                    }
                ]
            }
        ]
    },
    {
        "competency": "توسعه و مدیریت منابع انسانی",
        "subCompetencies": [
            {
                "title": "تامین و بکارگیری کارکنان",
                "details": [
                    {
                        "description": "امور مدیران",
                        "requiredCompetencyLevel": "زیاد"
                    },
                    {
                        "description": "پیگیری احکام هیئت مدیره شرکت های تابعه",
                        "requiredCompetencyLevel": "زیاد"
                    },
                    {
                        "description": "جابجایی کارکنان",
                        "requiredCompetencyLevel": "زیاد"
                    },
                    {
                        "description": "جذب و انتخاب",
                        "requiredCompetencyLevel": "زیاد"
                    },
                    {
                        "description": "قرارداد کارکنان",
                        "requiredCompetencyLevel": "زیاد"
                    },
                    {
                        "description": "ماموریت کارکنان",
                        "requiredCompetencyLevel": "زیاد"
                    },
                    {
                        "description": "مرخصی",
                        "requiredCompetencyLevel": "زیاد"
                    }
                ]
            },
            {
                "title": "انگیزش و نگهداشت",
                "details": [
                    {
                        "description": "مدیریت وام و تسهیلات",
                        "requiredCompetencyLevel": "متوسط"
                    }
                ]
            },
            {
                "title": "بهسازی کارکنان",
                "details": [
                    {
                        "description": "آموزش کارکنان",
                        "requiredCompetencyLevel": "زیاد"
                    }
                ]
            },
            {
                "title": "مدیریت اطلاعات کارکنان و تحلیل آن ها",
                "details": [
                    {
                        "description": "تهیه گزارش کارکرد",
                        "requiredCompetencyLevel": "زیاد"
                    },
                    {
                        "description": "گزارشات منابع انسانی",
                        "requiredCompetencyLevel": "زیاد"
                    },
                    {
                        "description": "مدیریت اطلاعات کارکنان",
                        "requiredCompetencyLevel": "زیاد"
                    }
                ]
            },
            {
                "title": "مدیریت ارتباطات کارکنان",
                "details": [
                    {
                        "description": "مدیریت ارتباطات کارکنان",
                        "requiredCompetencyLevel": "زیاد"
                    },
                    {
                        "description": "نظرسنجی از کارکنان",
                        "requiredCompetencyLevel": "زیاد"
                    }
                ]
            },
            {
                "title": "بازنشستگی و خروج کارکنان",
                "details": [
                    {
                        "description": "مدیریت خروج کارکنان",
                        "requiredCompetencyLevel": "زیاد"
                    }
                ]
            },
            {
                "title": "ساماندهی منابع انسانی",
                "details": [
                    {
                        "description": "برنامه ریزی منابع انسانی",
                        "requiredCompetencyLevel": "زیاد"
                    },
                    {
                        "description": "طراحی ساختار سازمانی",
                        "requiredCompetencyLevel": "زیاد"
                    }
                ]
            }
        ]
    },
    {
        "competency": "مدیریت تدارکات کالا و خدمات",
        "subCompetencies": [
            {
                "title": "خرید کالا",
                "details": [
                    {
                        "description": null,
                        "requiredCompetencyLevel": "متوسط"
                    }
                ]
            },
            {
                "title": "درخواست کالا از انبار",
                "details": [
                    {
                        "description": null,
                        "requiredCompetencyLevel": "متوسط"
                    }
                ]
            },
            {
                "title": "نگهداری دارایی‌ها",
                "details": [
                    {
                        "description": null,
                        "requiredCompetencyLevel": "متوسط"
                    }
                ]
            }
        ]
    },
    {
        "competency": "توسعه قابلیت های سازمانی",
        "subCompetencies": [
            {
                "title": "ارزیابی و خود ارزیابی تعالی سازمانی",
                "details": [
                    {
                        "description": null,
                        "requiredCompetencyLevel": "متوسط"
                    }
                ]
            }
        ]
    },
    {
        "competency": "توسعه و مدیریت منابع مالی",
        "subCompetencies": [
            {
                "title": "مدیریت عملیات خزانه داری",
                "details": [
                    {
                        "description": "صدور چک",
                        "requiredCompetencyLevel": "زیاد"
                    }
                ]
            },
            {
                "title": "مدیریت مالیات",
                "details": [
                    {
                        "description": "مدیریت بیمه و مالیات",
                        "requiredCompetencyLevel": "زیاد"
                    }
                ]
            },
            {
                "title": "حسابداری عمومی و گزارشات",
                "details": [
                    {
                        "description": "تهیه و تنظیم صورت های مالی",
                        "requiredCompetencyLevel": "زیاد"
                    }
                ]
            },
            {
                "title": "حسابداری پرداختنی ها",
                "details": [
                    {
                        "description": "تنخواه گردانی",
                        "requiredCompetencyLevel": "زیاد"
                    },
                    {
                        "description": "حقوق و دستمزد",
                        "requiredCompetencyLevel": "زیاد"
                    }
                ]
            },
            {
                "title": "حسابداری درآمد",
                "details": [
                    {
                        "description": "پردازش حساب های دریافتنی",
                        "requiredCompetencyLevel": "زیاد"
                    }
                ]
            }
        ]
    },
    {
        "competency": "حراست",
        "subCompetencies": [
            {
                "title": "تردد افراد بیگانه",
                "details": [
                    {
                        "description": null,
                        "requiredCompetencyLevel": "متوسط"
                    }
                ]
            },
            {
                "title": "حفاظت اموال",
                "details": [
                    {
                        "description": null,
                        "requiredCompetencyLevel": "متوسط"
                    }
                ]
            },
            {
                "title": "دبیرخانه رمز و محرمانه",
                "details": [
                    {
                        "description": null,
                        "requiredCompetencyLevel": "متوسط"
                    }
                ]
            },
            {
                "title": "گزارشات امنیتی",
                "details": [
                    {
                        "description": null,
                        "requiredCompetencyLevel": "متوسط"
                    }
                ]
            },
            {
                "title": "مدیریت پدافند غیر عامل",
                "details": [
                    {
                        "description": null,
                        "requiredCompetencyLevel": "متوسط"
                    }
                ]
            }
        ]
    },
    {
        "competency": "مدیریت و توسعه ریسک ها و عدم قطعیت های فناوری اطلاعات",
        "subCompetencies": [
            {
                "title": "مدیریت و توسعه ریسک ها و عدم قطعیت های فناوری اطلاعات",
                "details": [
                    {
                        "description": "امنیت شبکه",
                        "requiredCompetencyLevel": "زیاد"
                    }
                ]
            },
            {
                "title": "خلق و مدیریت پشتیبانی راه حل‌ها – خدمات",
                "details": [
                    {
                        "description": "پشتیبانی کاربران IT",
                        "requiredCompetencyLevel": "زیاد"
                    }
                ]
            }
        ]
    },
    {
        "competency": "مدیریت ارتباطات بیرونی",
        "subCompetencies": [
            {
                "title": "مدیریت طرح‌های روابط بیرونی",
                "details": [
                    {
                        "description": "پایش اخبار",
                        "requiredCompetencyLevel": "زیاد"
                    },
                    {
                        "description": "تشریفات",
                        "requiredCompetencyLevel": "زیاد"
                    },
                    {
                        "description": "تهیه و انتشار خبر",
                        "requiredCompetencyLevel": "زیاد"
                    },
                    {
                        "description": "مدیریت رخدادها",
                        "requiredCompetencyLevel": "زیاد"
                    },
                    {
                        "description": "مسئولیت اجتماعی",
                        "requiredCompetencyLevel": "زیاد"
                    }
                ]
            }
        ]
    }
]
